/**
 * Feature Specific Constants
 * Contains constants specific to features like missions, tools, evidence, and other domain-specific text
 */

export const MISSION_INFO_MESSAGE =
  'Las misiones son responsabilidades que un pragmático puede asumir cuando ha dominado este comportamiento y los adicionales requeridos.';
export const MISSION_INFO_MESSAGEALT =
  '  Cumplir una misión refleja la capacidad de resolver del pragmático en un reto, ya que permite observar cómo aplica sus habilidades técnicas y comportamentales para aportar valor al equipo y a la organización.';
export const MISSION_CONSIDERATIONS_TITLE = 'Consideraciones a tener en cuenta al crear una misión';
export const MISSION_CONSIDERATIONS = [
  'Puede ser que el pragmático requiera varios comportamientos para alcanzar esta misión.',
  'Un reto puede estar compuesto por varias misiones. Una descripción clara de cada misión facilitará la evaluación objetiva del desempeño y crecimiento del pragmático.',
];
export const MISSION_MANAGEMENT_HELP_LINK = 'Cómo crear una misión';
export const MISSION_MANAGEMENT_TITLE = 'Principales misiones del reto';
export const MISSION_MANAGEMENT_DESCRIPTION =
  'Busca o añade misiones asociadas con este conocimiento';

export const TOOLS_MESSAGES = {
  tech: 'Busca y añade herramientas ligadas a este enfoque para aplicar este comportamiento',
  tools: 'Busca y añade herramientas ligadas al comportamiento',
};
export const TOOLS_TITLE = 'Agregar herramientas';

export const BEHAVIOR_TECHNOLOGIES_TITLE = 'Enfoque del comportamiento';
export const BEHAVIOR_TECHNOLOGIES_DESCRIPTION =
  'Busca y añade enfoques o tecnologías principales con que se aplica este comportamiento';

export const EVALUATOR_VALORATION_MESSAGE_DESC =
  'Argumenta y proporciona links que respalden tu conocimiento y habilidades.';
export const EVALUATOR_VALORATION_MESSAGE_DESC_MESS =
  ' Argumentación y links que respaldan el conocimiento y las habilidades del pragmático.';
export const EVALUATOR_VALORATION_MESSAGE_TITLE = '¡Qué ejemplos te han hecho sentir orgulloso!';
export const EVIDENCE_TITLE = 'Título o comentario';
export const EVIDENCE_LINK = 'Comparte links';
export const LINK_EXAMPLE = 'Link ejemplos';
export const INVALID_LINK_MSG = 'Debe ser un enlace válido.';

export const NO_DESCRIPTION_PRAGMAPOWER = 'No tenemos descripción para este pragmapower';
export const NO_BEHAVIOR_DESCRIPTION_FOUND = 'No encontramos descripción para este comportamiento';

export const MAIN_CHAPTER = 'Chapter primario';
export const SECONDARY_CHAPTER = 'Chapter secundario';
export const COMPLEMENTARY_CHAPTER = 'Chapter complementario';
export const PRAGMATIC_INFORMATION = 'Información del pragmático';
export const WITHOUT_ASSESSMENT_STATE = 'Sin review de crecimiento';
export const VALORATION_TAB = 'Valoración';

export const PRAGMATIC = 'Pragmático';
export const TEAM_LEADER = 'Manager';
export const REVIEWER = 'Valorador';

export const UPDATE_INFORMATION = 'Actualizar Información';
export const TYPE_ASSESSMENT = 'valoración';
export const SAVE = 'Guardar';
export const CANCEL = 'Cancelar';
export const addEmail = 'Agrega un correo';
